import * as React from 'react'
import { TaskFileListConnected } from './TaskFileListConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TaskFileListExamples = () => {
  return (
    <div className="TaskFileListExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TaskFileListConnected />
      </Provider>
    </div>
  )
}
